<div class="row">
  <div class="col-md-6 form-group pl-0">
    <label for="exampleFormControlSelect1" class="control-label">{{
      "page.fromdate" | translate
    }}</label>
    <input
      type="date"
      [(ngModel)]="from"
      name="from"
      placeholder="from"
      (ngModelChange)="startDate($event)"
      class="form-control"
    />
  </div>
  <div class="col-md-6 form-group pl-0">
    <label for="exampleFormControlSelect1" class="control-label">{{
      "page.todate" | translate
    }}</label>
    <input
      type="date"
      [(ngModel)]="to"
      name="to"
      placeholder="to"
      [min]="from"
      (ngModelChange)="endDate($event)"
      class="form-control"
    />
  </div>
</div>
